// 租赁状态分组(筛选下拉)
export const RENT_STATUS_GROUP_OPTIONS = [
  { label: '全部', value: '' },
  { label: '租赁中', value: 1 },
  { label: '已退车', value: 2 },
]

// 付款方式(筛选下拉，payMode 单值)
export const PAY_MODE_OPTIONS = [
  { label: '全部', value: '' },
  { label: '日付', value: 10 },
  { label: '周付(满周)', value: 3 },
  { label: '周付(自然周)', value: 12 },
  { label: '月付(满月)', value: 4 },
  { label: '月付(自然月)', value: 5 },
]

// 付款方式 → el-tag type(按大类)：日付绿 / 周付黄 / 月付蓝(primary)
export function payModeTagType(payMode) {
  if (payMode === 10) return 'success'
  if (payMode === 3 || payMode === 12) return 'warning'
  if (payMode === 4 || payMode === 5) return '' // primary=蓝
  return 'info'
}

// 租赁状态 → el-tag type：含"退"字判红(已退车)，否则绿(租赁中)
export function rentStatusTagType(rentStatusName) {
  return rentStatusName && String(rentStatusName).includes('退')
    ? 'danger'
    : 'success'
}

// 账单类型 → el-tag type：租金蓝(primary) / 押金绿
export function billTypeTagType(billType) {
  return billType === 1 ? '' : 'success'
}
